/** The items grouped by key, groups and items in first-seen order. */
export const groupBy = <T, K>(items: Iterable<T>, keyOf: (item: T) => K): Map<K, T[]> => {
    const groups = new Map<K, T[]>();
    for (const item of items) {
        const key = keyOf(item);
        const group = groups.get(key);
        if (group) group.push(item); else groups.set(key, [item]);
    }
    return groups;
};
